export const TW = 'TW'
export const JP = 'JP'
export const TH = 'TH'
export const VN = 'VN'
